import { createFileRoute } from '@tanstack/react-router'
import { CallVendorsPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/call-vendors/')({
  component: CallVendorsPage,
  beforeLoad: requireRole(['admin']),
})
